<template>
  <slot
    :name="column.key"
    :value="cellValue"
    :item="item">
    <span
      :title="cellValue"
      :class="{
        highlighted: cellValue != null && highlightedColumns?.includes(column.property),
        error: validationErrors?.some((x) => x.entity === item && Object.keys(x.errors).includes(column.modelProperty)),
      }">
      <!-- Display change in the following format: {original} -> {new} -->
      <div
        v-if="showChanges && item.hasChangesFor != null && item.hasChangesFor(column)"
        class="flex-h">
        <span class="highlighted mr-2">{{ item.getChangeFor(column).from }}</span> →
        <span class="highlighted ml-2">{{ item.getChangeFor(column).to }}</span>
      </div>
      <!-- When rawValues are available (bulk v4), display them instead of the property value -->
      <template v-else-if="showRawValues && item.rawValues != null">{{ item.rawValues[column.property] }}</template>
      <template v-else-if="typeof cellValue === 'boolean'">
        {{ cellValue ? capitalize(i18n.t('actions.yes')) : capitalize(i18n.t('actions.no')) }}
      </template>
      <template v-else>{{ cellValue }}</template>
    </span>
  </slot>
</template>

<script lang="ts" setup>
  import { capitalize, computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  import TableColumn from '@/common/components/controls/table/TableColumn';

  const i18n = useI18n();
  interface IProps {
    column: TableColumn;
    item;
    showChanges: boolean;
    showRawValues: boolean;
    highlightedColumns?: string[];
    validationErrors?;
  }

  const { item, column } = defineProps<IProps>();

  const cellValue = computed(() => {
    if (item == null || column == null) {
      return null;
    }
    return item[column.key];
  });
</script>
